module.exports = __webpack_public_path__ + "80d77c7db3f2a4820c896e06c0d910bd.png";